import { useQuery } from 'react-query';
import {
	getBriefDebriefCalls,
	getCompanyById,
	getMyCompaniesListQuery,
	getMyCompaniesQuery,
	getRecruitersOfCompany,
	getScrapedPositionRecommendationDetails,
} from 'src/apis/company';
import {
	FilterCompaniesInput,
	GetAllRecruitersOfCompanyAPIResponse,
	GetBriefDebriefCallsResponse,
	GetCompanyByIdAPIResponse,
	GetMyCompaniesAPIResponse,
	GetMyCompaniesListAPIResponse,
	GetScrapedPositionRecommendationsAPIResponse,
} from 'types';

export const useGetMyCompaniesQuery = (
	isAccountManagerLoggedIn: boolean,
	payload: FilterCompaniesInput,
	onComplete?: (data: GetMyCompaniesAPIResponse) => void,
	onSettled?: () => void,
) => {
	return useQuery({
		queryKey: ['getMyCompaniesQuery', payload],
		queryFn: async () => (await getMyCompaniesQuery(payload)) as GetMyCompaniesAPIResponse,
		staleTime: 0,
		enabled: isAccountManagerLoggedIn,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onSettled: () => {
			onSettled && onSettled();
		},
	});
};

export const useGetMyCompaniesListQuery = (
	isAccountManagerLoggedIn: boolean,
	payload: string,
	onComplete?: (data: GetMyCompaniesListAPIResponse) => void,
	onSettled?: () => void,
) => {
	return useQuery({
		queryKey: ['getMyCompaniesListQuery', payload],
		queryFn: async () => (await getMyCompaniesListQuery(payload)) as GetMyCompaniesListAPIResponse,
		staleTime: 0,
		enabled: isAccountManagerLoggedIn && payload.length > 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onSettled: () => {
			onSettled && onSettled();
		},
	});
};

export const useGetScrapedPositionDetailsQuery = (
	isAccountManagerLoggedIn: boolean,
	payload: { companyId: string },
	onComplete?: (data: GetMyCompaniesAPIResponse) => void,
	onSettled?: () => void,
) => {
	return useQuery({
		queryKey: ['getScrapedPositionRecommendationDetails', payload],
		queryFn: async () =>
			(await getScrapedPositionRecommendationDetails(payload)) as GetScrapedPositionRecommendationsAPIResponse,
		staleTime: 0,
		enabled: isAccountManagerLoggedIn,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onSettled: () => {
			onSettled && onSettled();
		},
	});
};

export const useGetAllRecruitersOfCompany = (id: string, onComplete?: (data: GetMyCompaniesAPIResponse) => void) => {
	return useQuery({
		queryKey: ['getRecruitersOfCompany', id],
		queryFn: async () => (await getRecruitersOfCompany(id)) as GetAllRecruitersOfCompanyAPIResponse,
		staleTime: 0,
		enabled: !!id && id !== 'undefined',
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};

export const useGetCompanyByIdQuery = (id: string, onComplete?: (data: GetCompanyByIdAPIResponse) => void) => {
	return useQuery({
		queryKey: ['getCompanyById', id],
		queryFn: async () => (await getCompanyById(id)) as GetCompanyByIdAPIResponse,
		staleTime: 0,
		enabled: !!id && id !== 'undefined',
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};
